export { default } from './withMobileDialog';